import { createContext, useRef } from "react";
import { Mutate, StoreApi, UseBoundStore } from "zustand";
import { createSemanticModelStore } from "./createSemanticModelStore";
import { Mutators, SemanticModelStore } from "./defaultState";

export const SemanticModelContext = createContext<UseBoundStore<StoreApi<SemanticModelStore>> | null>(null);

export let useSemanticModelStore: UseBoundStore<Mutate<StoreApi<SemanticModelStore>, Mutators>>;

export function SemanticModelProvider({ children }: React.PropsWithChildren) {
  const storeRef = useRef<UseBoundStore<Mutate<StoreApi<SemanticModelStore>, Mutators>>>();

  if (!storeRef.current) {
    useSemanticModelStore = createSemanticModelStore();
    storeRef.current = useSemanticModelStore;
  }

  return <SemanticModelContext.Provider value={storeRef.current}>{children}</SemanticModelContext.Provider>;
}
